import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import TableHeader from 'modules/_shared/Table/components/TableHeader';
import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';

const CustomLandingAnalyticsTableHeader: FC = () => {
  const { t } = useTranslate();

  const columns: ColumnCell[] = [
    {
      key: 'partner',
      content: t('ColumnPartner'),
    },
    {
      key: 'action',
      content: t('ColumnAction'),
    },
    {
      key: 'section',
      content: t('ColumnSection'),
      hideOnMobile: true,
    },
    {
      key: 'folder',
      content: t('ColumnFolder'),
      hideOnMobile: true,
    },
    {
      key: 'content',
      content: t('ColumnContent'),
      hideOnMobile: true,
    },
    {
      key: 'datetime',
      content: t('ColumnDateTime'),
      textPosition: 'right',
    },
    {
      key: 'device',
      content: t('ColumnDevice'),
      hideOnMobile: true,
    },
    {
      key: 'geolocation',
      content: t('ColumnGeolocation'),
      hideOnMobile: true,
    },
  ];

  return <TableHeader columns={columns} />;
};

export default CustomLandingAnalyticsTableHeader;
